import type { Ref } from 'vue'
import { ref } from 'vue'
import type { ProviderInterface } from '../ProviderInterface'
import { Flag } from '../Flag'

export class Simple implements ProviderInterface {
  private readonly enabledFlags: Flag[] = [
    Flag.TEST,
    Flag.PMS_MODULE_CONTACT_PERSON_GRID,
    Flag.PMS_MODULE_GUEST_GRID,
    Flag.PMS_MODULE_COMPANY_GRID,
    Flag.HOUSEKEEPING_TASKS,
    Flag.HOUSEKEEPING_TEMPORARY_ASSIGNMENT_CREATE,
    Flag.HOUSEKEEPING_LOGIN_LINKS,
    Flag.PMS_SETTINGS_RESERVATION_ENABLED,
    Flag.FOLIO_DOCUMENTS_EDIT,
    Flag.INVOICING_DOCUMENTS_BATCH,
    Flag.INVOICING_DOCUMENTS_ISSUE_RELATED,
    Flag.INVOICING_DOCUMENTS_CREATE_CURRENCY,
    Flag.CRM_SALES_CASES_IMPLEMENTATION,
    Flag.PMS_COMMUNICATION_MODULE_ENABLED,
    Flag.PMS_COMMUNICATION_WHATSAPP_ENABLED,
    Flag.INVOICING_GIFT_VOUCHERS_ENABLED,
    Flag.INVOICING_PAYMENT_PRESCRIPTIONS_ENABLED,
    Flag.PMS_RESERVATION_HISTORY,
    Flag.PMS_OFFERS_ENABLED,
    Flag.PMS_SETTINGS_DASHBOARD_ENABLED,
    Flag.PMS_RESERVATIONS_OPTIMIZER_ENABLED,
    Flag.PMS_CLOSED_TERM_ALLOCATION_ENABLED,
    Flag.PMS_POS_TRANSACTION_WINDOW,
    Flag.MYCONNECTION_EDIT,
    Flag.PMS_SERVICE_MAPPING_ENABLED,
    Flag.PMS_EXCHANGE_RATES,
    Flag.PMS_TAX_SETTINGS_ENABLED,
    Flag.PMS_CONNECTED_ROOMS_ENABLED,
    Flag.PMS_AGENT_ENABLED,
    Flag.PMS_RESERVATION_DETAIL_COMMUNICATION_TAB,
  ]

  isEnabled(flag: Flag): Ref<boolean> {
    let result = false
    this.enabledFlags.forEach((enabledFlag) => {
      if (enabledFlag === flag) {
        result = true
      }
    })

    return ref(result)
  }

  waitForInit(): Promise<void> {
    return new Promise<void>((resolve) => {
      resolve()
    })
  }

  changeContext(): void {
    return
  }
}
